import { gql } from 'graphql-tag'

export default gql`
  fragment GlobalDataPlatformIndustryFragment on GlobalDataPlatformIndustry {
    sys {
      id
    }
    contentType: __typename
    internalName
    name
  }
`
